angular.module('env.custom.customTemplateResolver', [])

    .provider('customTemplateResolver', function CustomTemplateResolver() {

        //region Public methods

        /**
         * Returns HTML containing declaration of the custom template tag
         * @param name - alias name of the HTML template to resolve from customisation config
         * @param _default - default temaplate URI value to use in case of any error (can't resolve template from config or not exist)
         */
        this.get = function (name, _default) {
            return _.string.sprintf('<custom-template name="\'%s\'" failover-uri="%s"></custom-template>', name, _default);
        };

        //endregion


        this.$get = function () {
            return new CustomTemplateResolver();
        };
    })

;